
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  subnav: true,
  maxTocLevel: 4,
  layout: 'reference',
  noIndex: true,
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4,
  description: 'API reference for endpoints and webhooks associated with Plaid Check.',
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Callout = makeShortcode("Callout");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Plaid Check' subtitle='API reference for Plaid Check endpoints and webhooks' compact mdxType="Header" />
    <Callout warning mdxType="Callout">
      <p>{`This page provides documentation for legacy endpoints used for Plaid Check integrations prior to October 2026. For the newest CRA endpoints, see the `}<a parentName="p" {...{
          "href": "/docs/api/products/check/"
        }}>{`Plaid Check API reference`}</a>{`.`}</p>
    </Callout>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Endpoints`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/check_report/base_report/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve the base Consumer Report for your user`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/check_report/income_insights/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve income insights from your user's banks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/check_report/network_insights/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve connection insights from the Plaid network (beta)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/check_report/partner_insights/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve cash flow insights from our partners`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/check_report/pdf/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve a Consumer Report in PDF format`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/check_report/cashflow_insights/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve Cash Flow Insights report`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/check_report/lend_score/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve a Plaid LendScore generated from your user's banking data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/check_report/verification/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve Verification Reports (Home Lending Report, Employment Refresh) for your user`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/check_report/verification/pdf/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve Verification Reports in PDF format`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/check_report/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Generate a new Consumer Report for your user with the latest data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/servicing/subscription/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Subscribe a user to recurring report generation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/servicing/subscription/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve a Servicing subscription`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/servicing/subscription/list`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List a user's Servicing subscriptions`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/servicing/subscription/update`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Update a Servicing subscription`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/servicing/subscription/delete`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete a Servicing subscription`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/monitoring_insights/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get Cash Flow Updates (deprecated)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/monitoring_insights/subscribe`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Subscribe to Cash Flow Updates (deprecated)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/cra/monitoring_insights/unsubscribe`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Unsubscribe from Cash Flow Updates (deprecated)`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`See also`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/api/users/migrate-to-new-user-apis"
            }}>{`Migrate to new User APIs`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Migration guide for existing Consumer Report integrations on legacy User APIs`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/check/servicing"
            }}>{`Servicing`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guide to subscribing users to recurring Consumer Report updates`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/link/token/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create a token for initializing a Link session with Plaid Check`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/user/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create a user for use with Plaid Check`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/user/update`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Update an existing user token to work with Plaid Check, or change user details`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/user/items/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returns Items associated with a user along with their corresponding statuses`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/sandbox/cra/servicing/simulate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Simulate a Servicing report generation for a subscription (Sandbox only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/sandbox/cra/cashflow_updates/update`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Manually trigger a cashflow insights update for a user (Sandbox only)`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#user_check_report_ready"
            }}><inlineCode parentName="a">{`USER_CHECK_REPORT_READY`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A Consumer Report is ready to be retrieved`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#user_check_report_failed"
            }}><inlineCode parentName="a">{`USER_CHECK_REPORT_FAILED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Plaid Check failed to create a report`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#check_report_ready"
            }}><inlineCode parentName="a">{`CHECK_REPORT_READY`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A Consumer Report is ready to be retrieved (legacy)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#check_report_failed"
            }}><inlineCode parentName="a">{`CHECK_REPORT_FAILED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Plaid Check failed to create a report (legacy)`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Servicing webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#cra_report_updated"
            }}><inlineCode parentName="a">{`CRA_REPORT_UPDATED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A CRA report has been refreshed`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Legacy Cash Flow Updates webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#cash_flow_insights_updated"
            }}><inlineCode parentName="a">{`CASH_FLOW_INSIGHTS_UPDATED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Insights have been refreshed (Cash Flow Updates)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#insights_updated"
            }}><inlineCode parentName="a">{`INSIGHTS_UPDATED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Insights have been refreshed (legacy)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#large_deposit_detected"
            }}><inlineCode parentName="a">{`LARGE_DEPOSIT_DETECTED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A large deposit over $5000 has been detected (legacy)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#low_balance_detected"
            }}><inlineCode parentName="a">{`LOW_BALANCE_DETECTED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Current balance has crossed below $100 (legacy)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#new_loan_payment_detected"
            }}><inlineCode parentName="a">{`NEW_LOAN_PAYMENT_DETECTED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A new loan payment has been detected (legacy)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#nsf_overdraft_detected"
            }}><inlineCode parentName="a">{`NSF_OVERDRAFT_DETECTED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An overdraft transaction has been detected (legacy)`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "cracheck_reportbase_reportget"
    }}>{`/cra/check_report/base_report/get`}</h4>
    <Schema method='POST' route='/cra/check_report/base_report/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/check_report/base_report/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/check_report/base_report/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craCheckReportBaseReportGet({
    user_id: 'usr_9nSp2KuZ2x4JDw',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraCheckReportBaseReportGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.cra_check_report_base_report_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraCheckReportBaseReportGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.cra_check_report_base_report_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraCheckReportBaseReportGetRequest request = new CraCheckReportBaseReportGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CraCheckReportBaseReportGetResponse> response = client
  .craCheckReportBaseReportGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraCheckReportBaseReportGetRequest();
request.SetUserId("usr_9nSp2KuZ2x4JDw");

response, _, err := client.PlaidApi.
  CraCheckReportBaseReportGet(ctx).
  CraCheckReportBaseReportGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraCheckReportBaseReportGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.CheckReport.GetBaseReport(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/check_report/base_report/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "cracheck_reportincome_insightsget"
    }}>{`/cra/check_report/income_insights/get`}</h4>
    <Schema method='POST' route='/cra/check_report/income_insights/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/check_report/income_insights/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/check_report/income_insights/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craCheckReportIncomeInsightsGet({
    user_id: 'usr_9nSp2KuZ2x4JDw',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraCheckReportIncomeInsightsGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.cra_check_report_income_insights_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraCheckReportIncomeInsightsGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.cra_check_report_income_insights_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraCheckReportIncomeInsightsGetRequest request = new CraCheckReportIncomeInsightsGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CraCheckReportIncomeInsightsGetResponse> response = client
  .craCheckReportIncomeInsightsGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraCheckReportIncomeInsightsGetRequest();
request.SetUserId("usr_9nSp2KuZ2x4JDw");

response, _, err := client.PlaidApi.
  CraCheckReportIncomeInsightsGet(ctx).
  CraCheckReportIncomeInsightsGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraCheckReportIncomeInsightsGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.CheckReport.GetIncomeInsights(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/check_report/income_insights/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "cracheck_reportnetwork_insightsget"
    }}>{`/cra/check_report/network_insights/get`}</h4>
    <Schema method='POST' route='/cra/check_report/network_insights/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/check_report/network_insights/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/check_report/network_insights/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craCheckReportNetworkInsightsGet({
    user_id: 'usr_9nSp2KuZ2x4JDw',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraCheckReportNetworkInsightsGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.cra_check_report_network_insights_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraCheckReportNetworkInsightsGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.cra_check_report_network_insights_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraCheckReportNetworkInsightsGetRequest request = new CraCheckReportNetworkInsightsGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CraCheckReportNetworkInsightsGetResponse> response = client
  .craCheckReportNetworkInsightsGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraCheckReportNetworkInsightsGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw");

response, _, err := client.PlaidApi.
  CraCheckReportNetworkInsightsGet(ctx).
  CraCheckReportNetworkInsightsGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraCheckReportNetworkInsightsGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.CheckReport.GetNetworkInsights(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/check_report/network_insights/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "cracheck_reportpartner_insightsget"
    }}>{`/cra/check_report/partner_insights/get`}</h4>
    <Schema method='POST' route='/cra/check_report/partner_insights/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/check_report/partner_insights/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/check_report/partner_insights/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craCheckReportPartnerInsightsGet({
    user_id: 'usr_9nSp2KuZ2x4JDw',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraCheckReportPartnerInsightsGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.cra_check_report_partner_insights_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraCheckReportPartnerInsightsGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.cra_check_report_partner_insights_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraCheckReportPartnerInsightsGetRequest request = new CraCheckReportPartnerInsightsGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CraCheckReportPartnerInsightsGetResponse> response = client
  .craCheckReportPartnerInsightsGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraCheckReportPartnerInsightsGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.
  CraCheckReportPartnerInsightsGet(ctx).
  CraCheckReportPartnerInsightsGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraCheckReportPartnerInsightsGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.CheckReport.GetPartnerInsights(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/check_report/partner_insights/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "cracheck_reportpdfget"
    }}>{`/cra/check_report/pdf/get`}</h4>
    <Schema method='POST' route='/cra/check_report/pdf/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/check_report/pdf/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/check_report/pdf/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}' \\
-o 'report.pdf'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craCheckReportPdfGet(
    {
      user_id: 'usr_9nSp2KuZ2x4JDw',
    },
    {
      responseType: 'arraybuffer',
    },
  );
  const pdf = response.data.toString('base64');
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraCheckReportPDFGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.cra_check_report_pdf_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraCheckReportPDFGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.cra_check_report_pdf_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraCheckReportPDFGetRequest request = new CraCheckReportPDFGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<ResponseBody> response = client
  .craCheckReportPdfGet(request)
  .execute();
byte[] pdf = response.body().bytes();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraCheckReportPDFGetRequest();
request.SetUserId("usr_9nSp2KuZ2x4JDw");

response, _, err := client.PlaidApi.
  CraCheckReportPdfGet(ctx).
  CraCheckReportPDFGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraCheckReportPdfGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.CheckReport.GetPdf(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <h5 {...{
      "id": "response"
    }}>{`Response`}</h5>
    <p>{`This endpoint returns binary PDF data. `}<a parentName="p" {...{
        "href": "https://plaid.com/documents/sample-check-report.pdf"
      }}>{`View a sample Check Report PDF.`}</a>{`
`}<a parentName="p" {...{
        "href": "https://plaid.com/documents/sample-check-report-with-income.pdf"
      }}>{`View a sample Check Report PDF containing Income Insights.`}</a></p>
    <h4 {...{
      "id": "cracheck_reportcashflow_insightsget"
    }}>{`/cra/check_report/cashflow_insights/get`}</h4>
    <Schema method='POST' route='/cra/check_report/cashflow_insights/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/check_report/cashflow_insights/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/check_report/cashflow_insights/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craCheckReportCashflowInsightsGet({
    user_id: 'usr_9nSp2KuZ2x4JDw',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraCheckReportCashflowInsightsGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.cra_check_report_cashflow_insights_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraCheckReportCashflowInsightsGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.cra_check_report_cashflow_insights_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraCheckReportCashflowInsightsGetRequest request = new CraCheckReportCashflowInsightsGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CraCheckReportCashflowInsightsGetResponse> response = client
  .craCheckReportCashflowInsightsGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraCheckReportCashflowInsightsGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.
  CraCheckReportCashflowInsightsGet(ctx).
  CraCheckReportCashflowInsightsGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraCheckReportCashflowInsightsGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.CheckReport.GetCashflowInsights(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/check_report/cashflow_insights/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "cracheck_reportlend_scoreget"
    }}>{`/cra/check_report/lend_score/get`}</h4>
    <Schema method='POST' route='/cra/check_report/lend_score/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/check_report/lend_score/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/check_report/lend_score/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craCheckReportLendScoreGet({
    user_id: 'usr_9nSp2KuZ2x4JDw',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraCheckReportLendScoreGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.cra_check_report_lend_score_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraCheckReportLendScoreGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.cra_check_report_lend_score_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraCheckReportLendScoreGetRequest request = new CraCheckReportLendScoreGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CraCheckReportLendScoreGetResponse> response = client
  .craCheckReportLendScoreGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraCheckReportLendScoreGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.
  CraCheckReportLendScoreGet(ctx).
  CraCheckReportLendScoreGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraCheckReportLendScoreGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.CheckReport.GetLendScore(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/check_report/lend_score/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "cracheck_reportverificationget"
    }}>{`/cra/check_report/verification/get`}</h4>
    <Schema method='POST' route='/cra/check_report/verification/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/check_report/verification/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/check_report/verification/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "reports_requested": ["VOA", "EMPLOYMENT_REFRESH"],
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craCheckReportVerificationGet({
    user_id: 'usr_9nSp2KuZ2x4JDw',
    reports_requested: ['VOA', 'EMPLOYMENT_REFRESH'],
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraCheckReportVerificationGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw',
  reports_requested=[CraCheckReportVerificationGetReportType('VOA'), CraCheckReportVerificationGetReportType('EMPLOYMENT_REFRESH')],
  employment_refresh_options={
    'days_requested': 60,
  },
)

response = client.cra_check_report_verification_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraCheckReportVerificationGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw',
    reports_requested: ['VOA', 'EMPLOYMENT_REFRESH'],
  }
)

response = client.cra_check_report_verification_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraCheckReportVerificationGetRequest request = new CraCheckReportVerificationGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw")
  .reportsRequested(Arrays.asList(CraCheckReportVerificationGetReportType.VOA, CraCheckReportVerificationGetReportType.EMPLOYMENT_REFRESH));

Response<CraCheckReportVerificationGetResponse> response = client
  .craCheckReportVerificationGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`reportsRequested := []plaid.CraCheckReportVerificationGetReportType{
  plaid.CRACHECKREPORTVERIFICATIONGETREPORTTYPE_VOA,
  plaid.CRACHECKREPORTVERIFICATIONGETREPORTTYPE_EMPLOYMENT_REFRESH,
}

request := plaid.NewCraCheckReportVerificationGetRequest(reportsRequested)
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.
  CraCheckReportVerificationGet(ctx).
  CraCheckReportVerificationGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`reportsRequested := []plaid.CraCheckReportVerificationGetReportType{
    plaid.CraCheckReportVerificationGetReportTypeVoa,
    plaid.CraCheckReportVerificationGetReportTypeEmploymentRefresh,
}

request := &plaid.CraCheckReportVerificationGetRequest{ReportsRequested: reportsRequested}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.CheckReport.GetVerification(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/check_report/verification/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "cracheck_reportverificationpdfget"
    }}>{`/cra/check_report/verification/pdf/get`}</h4>
    <Schema method='POST' route='/cra/check_report/verification/pdf/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/check_report/verification/pdf/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/check_report/verification/pdf/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw",
  "reports_requested": ["voa"]
}' \\
-o 'verification.pdf'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craCheckReportVerificationPdfGet(
    {
      user_id: 'usr_9nSp2KuZ2x4JDw',
      reports_requested: ['voa'],
    },
    {
      responseType: 'arraybuffer',
    },
  );
  const pdf = response.data.toString('base64');
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraCheckReportVerificationPdfGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw',
  reports_requested=[CraCheckReportVerificationPdfReportType('voa')],
)
response = client.cra_check_report_verification_pdf_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraCheckReportVerificationPdfGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw',
    reports_requested: ['voa'],
  }
)
response = client.cra_check_report_verification_pdf_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraCheckReportVerificationPdfGetRequest request = new CraCheckReportVerificationPdfGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw")
  .reportsRequested(new HashSet<>(Arrays.asList(CraCheckReportVerificationPdfReportType.VOA)));
Response<ResponseBody> response = client
  .craCheckReportVerificationPdfGet(request)
  .execute();
byte[] pdf = response.body().bytes();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraCheckReportVerificationPdfGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")
request.SetReportsRequested([]plaid.CraCheckReportVerificationPdfReportType{plaid.CRACHECKREPORTVERIFICATIONPDFREPORTTYPE_VOA})
response, _, err := client.PlaidApi.
  CraCheckReportVerificationPdfGet(ctx).
  CraCheckReportVerificationPdfGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraCheckReportVerificationPdfGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")
request.ReportsRequested = []plaid.CraCheckReportVerificationPdfReportType{plaid.CraCheckReportVerificationPdfReportTypeVoa}
response, err := client.CheckReport.GetVerificationPdf(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <h5 {...{
      "id": "response-1"
    }}>{`Response`}</h5>
    <p>{`This endpoint returns binary PDF data. View a sample `}<a parentName="p" {...{
        "href": "https://plaid.com/documents/sample-mortgage-verification-voa.pdf"
      }}>{`Home Lending Report (aka VoA Report)`}</a>{` or `}<a parentName="p" {...{
        "href": "https://plaid.com/documents/sample-mortgage-verification-voe.pdf"
      }}>{`Employment Refresh`}</a>{` report.`}</p>
    <h4 {...{
      "id": "cracheck_reportcreate"
    }}>{`/cra/check_report/create`}</h4>
    <Schema method='POST' route='/cra/check_report/create' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/check_report/create' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/check_report/create \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw",
  "webhook": "https://sample-web-hook.com",
  "days_requested": 365,
  "consumer_report_permissible_purpose": "LEGITIMATE_BUSINESS_NEED_OTHER"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craCheckReportCreate({
    user_id: 'usr_9nSp2KuZ2x4JDw',
    webhook: 'https://sample-web-hook.com',
    days_requested: 365,
    consumer_report_permissible_purpose: 'LEGITIMATE_BUSINESS_NEED_OTHER',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraCheckReportCreateRequest(
  user_id='usr_9nSp2KuZ2x4JDw',
  webhook='https://sample-web-hook.com',
  days_requested=365,
  consumer_report_permissible_purpose=ConsumerReportPermissiblePurpose('LEGITIMATE_BUSINESS_NEED_OTHER'),
)

response = client.cra_check_report_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraCheckReportCreateRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw',
    webhook: 'https://sample-web-hook.com',
    days_requested: 365,
    consumer_report_permissible_purpose: 'LEGITIMATE_BUSINESS_NEED_OTHER',
  }
)

response = client.cra_check_report_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraCheckReportCreateRequest request = new CraCheckReportCreateRequest()
  .userId("usr_9nSp2KuZ2x4JDw")
  .webhook("https://sample-web-hook.com")
  .daysRequested(365)
  .consumerReportPermissiblePurpose(ConsumerReportPermissiblePurpose.LEGITIMATE_BUSINESS_NEED_OTHER);

Response<CraCheckReportCreateResponse> response = client
  .craCheckReportCreate(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraCheckReportCreateRequest(
  "https://sample-web-hook.com",
  365,
  plaid.CONSUMERREPORTPERMISSIBLEPURPOSE_LEGITIMATE_BUSINESS_NEED_OTHER,
)
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.
  CraCheckReportCreate(ctx).
  CraCheckReportCreateRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraCheckReportCreateRequest{
    Webhook:                          "https://sample-web-hook.com",
    DaysRequested:                    365,
    ConsumerReportPermissiblePurpose: plaid.ConsumerReportPermissiblePurposeLegitimateBusinessNeedOther,
}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.CheckReport.Create(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/check_report/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "craservicingsubscriptioncreate"
    }}>{`/cra/servicing/subscription/create`}</h4>
    <Schema method='POST' route='/cra/servicing/subscription/create' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/servicing/subscription/create' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/servicing/subscription/create \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw",
  "scope": "CLIENT_USER",
  "cadence": "DAILY",
  "webhook": "https://example.com/webhook",
  "products": [
    { "product": "cra_base_report", "version": "V1" }
  ]
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craServicingSubscriptionCreate({
    user_id: 'usr_9nSp2KuZ2x4JDw',
    scope: 'CLIENT_USER',
    cadence: 'DAILY',
    webhook: 'https://example.com/webhook',
    products: [{ product: 'cra_base_report', version: 'V1' }],
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraServicingSubscriptionCreateRequest(
  user_id='usr_9nSp2KuZ2x4JDw',
  scope=CraReportScope('CLIENT_USER'),
  cadence=CraSubscriptionCadence('DAILY'),
  webhook='https://example.com/webhook',
  products=[CraSubscriptionProductConfig(CraBaseReportProductConfig(product='cra_base_report', version=CraProductVersion('V1')))]
)

response = client.cra_servicing_subscription_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraServicingSubscriptionCreateRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw',
    scope: 'CLIENT_USER',
    cadence: 'DAILY',
    webhook: 'https://example.com/webhook',
    products: [{ product: 'cra_base_report', version: 'V1' }]
  }
)

response = client.cra_servicing_subscription_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraServicingSubscriptionCreateRequest request = new CraServicingSubscriptionCreateRequest()
  .userId("usr_9nSp2KuZ2x4JDw")
  .scope(CraReportScope.CLIENT_USER)
  .cadence(CraSubscriptionCadence.DAILY)
  .webhook("https://example.com/webhook")
  .products(List.of(new CraSubscriptionProductConfig(new CraBaseReportProductConfig()
    .product(CraBaseReportProductConfig.ProductEnum.CRA_BASE_REPORT)
    .version(CraProductVersion.V1))));

Response<CraServicingSubscriptionCreateResponse> response = client
  .craServicingSubscriptionCreate(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraServicingSubscriptionCreateRequest("usr_9nSp2KuZ2x4JDw", plaid.CRAREPORTSCOPE_CLIENT_USER, []plaid.CraSubscriptionProductConfig{
  plaid.CraBaseReportProductConfigAsCraSubscriptionProductConfig(plaid.NewCraBaseReportProductConfig("cra_base_report", "V1")),
});
request.SetCadence(plaid.CRASUBSCRIPTIONCADENCE_DAILY);
request.SetWebhook("https://example.com/webhook");

response, _, err := client.PlaidApi.
  CraServicingSubscriptionCreate(ctx).
  CraServicingSubscriptionCreateRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    servicing "github.com/plaid/plaid-go/v49/servicing"
)

request := &servicing.CraServicingSubscriptionCreateRequest{
    Cadence: plaid.CraSubscriptionCadenceDaily.Ptr(),
    Products: []*plaid.CraSubscriptionProductConfig{
        &plaid.CraSubscriptionProductConfig{
            CraBaseReport: &plaid.CraBaseReportProductConfig{
                Version: "V1",
            },
        },
    },
    Scope:   plaid.CraReportScopeClientUser,
    UserID:  "usr_9nSp2KuZ2x4JDw",
    Webhook: plaid.String("https://example.com/webhook"),
}
response, err := client.Servicing.Subscription.Create(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/servicing/subscription/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "craservicingsubscriptionget"
    }}>{`/cra/servicing/subscription/get`}</h4>
    <Schema method='POST' route='/cra/servicing/subscription/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/servicing/subscription/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/servicing/subscription/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "subscription_id": "cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craServicingSubscriptionGet({
    subscription_id: 'cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraServicingSubscriptionGetRequest(
  subscription_id='cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b'
)

response = client.cra_servicing_subscription_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraServicingSubscriptionGetRequest.new(
  {
    subscription_id: 'cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b'
  }
)

response = client.cra_servicing_subscription_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraServicingSubscriptionGetRequest request = new CraServicingSubscriptionGetRequest()
  .subscriptionId("cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b");

Response<CraServicingSubscriptionGetResponse> response = client
  .craServicingSubscriptionGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraServicingSubscriptionGetRequest("cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b");

response, _, err := client.PlaidApi.
  CraServicingSubscriptionGet(ctx).
  CraServicingSubscriptionGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    servicing "github.com/plaid/plaid-go/v49/servicing"
)

request := &servicing.CraServicingSubscriptionGetRequest{
    SubscriptionID: "cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b",
}
response, err := client.Servicing.Subscription.Get(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/servicing/subscription/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "craservicingsubscriptionlist"
    }}>{`/cra/servicing/subscription/list`}</h4>
    <Schema method='POST' route='/cra/servicing/subscription/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/servicing/subscription/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/servicing/subscription/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craServicingSubscriptionList({
    user_id: 'usr_9nSp2KuZ2x4JDw',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraServicingSubscriptionListRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.cra_servicing_subscription_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraServicingSubscriptionListRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.cra_servicing_subscription_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraServicingSubscriptionListRequest request = new CraServicingSubscriptionListRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CraServicingSubscriptionListResponse> response = client
  .craServicingSubscriptionList(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraServicingSubscriptionListRequest("usr_9nSp2KuZ2x4JDw");

response, _, err := client.PlaidApi.
  CraServicingSubscriptionList(ctx).
  CraServicingSubscriptionListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    servicing "github.com/plaid/plaid-go/v49/servicing"
)

request := &servicing.CraServicingSubscriptionListRequest{
    UserID: "usr_9nSp2KuZ2x4JDw",
}
response, err := client.Servicing.Subscription.List(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/servicing/subscription/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "craservicingsubscriptionupdate"
    }}>{`/cra/servicing/subscription/update`}</h4>
    <Schema method='POST' route='/cra/servicing/subscription/update' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/servicing/subscription/update' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/servicing/subscription/update \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "subscription_id": "cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b",
  "webhook": "https://example.com/new-webhook",
  "products": [
    { "product": "cra_base_report", "version": "V1" }
  ]
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craServicingSubscriptionUpdate({
    subscription_id: 'cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b',
    webhook: 'https://example.com/new-webhook',
    products: [{ product: 'cra_base_report', version: 'V1' }],
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraServicingSubscriptionUpdateRequest(
  subscription_id='cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b',
  webhook='https://example.com/new-webhook',
  products=[CraSubscriptionProductConfig(CraBaseReportProductConfig(product='cra_base_report', version=CraProductVersion('V1')))]
)

response = client.cra_servicing_subscription_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraServicingSubscriptionUpdateRequest.new(
  {
    subscription_id: 'cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b',
    webhook: 'https://example.com/new-webhook',
    products: [{ product: 'cra_base_report', version: 'V1' }]
  }
)

response = client.cra_servicing_subscription_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraServicingSubscriptionUpdateRequest request = new CraServicingSubscriptionUpdateRequest()
  .subscriptionId("cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b")
  .webhook("https://example.com/new-webhook")
  .products(List.of(new CraSubscriptionProductConfig(new CraBaseReportProductConfig()
    .product(CraBaseReportProductConfig.ProductEnum.CRA_BASE_REPORT)
    .version(CraProductVersion.V1))));

Response<CraServicingSubscriptionUpdateResponse> response = client
  .craServicingSubscriptionUpdate(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraServicingSubscriptionUpdateRequest("cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b");
request.SetWebhook("https://example.com/new-webhook");
request.SetProducts([]plaid.CraSubscriptionProductConfig{
  plaid.CraBaseReportProductConfigAsCraSubscriptionProductConfig(plaid.NewCraBaseReportProductConfig("cra_base_report", "V1")),
});

response, _, err := client.PlaidApi.
  CraServicingSubscriptionUpdate(ctx).
  CraServicingSubscriptionUpdateRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    servicing "github.com/plaid/plaid-go/v49/servicing"
)

request := &servicing.CraServicingSubscriptionUpdateRequest{
    Products: []*plaid.CraSubscriptionProductConfig{
        &plaid.CraSubscriptionProductConfig{
            CraBaseReport: &plaid.CraBaseReportProductConfig{
                Version: "V1",
            },
        },
    },
    SubscriptionID: "cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b",
    Webhook:        plaid.String("https://example.com/new-webhook"),
}
response, err := client.Servicing.Subscription.Update(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/servicing/subscription/update' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "craservicingsubscriptiondelete"
    }}>{`/cra/servicing/subscription/delete`}</h4>
    <Schema method='POST' route='/cra/servicing/subscription/delete' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/servicing/subscription/delete' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/servicing/subscription/delete \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "subscription_id": "cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craServicingSubscriptionDelete({
    subscription_id: 'cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraServicingSubscriptionDeleteRequest(
  subscription_id='cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b'
)

response = client.cra_servicing_subscription_delete(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraServicingSubscriptionDeleteRequest.new(
  {
    subscription_id: 'cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b'
  }
)

response = client.cra_servicing_subscription_delete(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraServicingSubscriptionDeleteRequest request = new CraServicingSubscriptionDeleteRequest()
  .subscriptionId("cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b");

Response<CraServicingSubscriptionDeleteResponse> response = client
  .craServicingSubscriptionDelete(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraServicingSubscriptionDeleteRequest("cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b");

response, _, err := client.PlaidApi.
  CraServicingSubscriptionDelete(ctx).
  CraServicingSubscriptionDeleteRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    servicing "github.com/plaid/plaid-go/v49/servicing"
)

request := &servicing.CraServicingSubscriptionDeleteRequest{
    SubscriptionID: "cra-sub-production-8f2b1c0a-3d4e-5f60-7a8b-9c0d1e2f3a4b",
}
response, err := client.Servicing.Subscription.Delete(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/servicing/subscription/delete' type='response' mdxType="Schema" />
    <h3 {...{
      "id": "legacy-cash-flow-updates-endpoints"
    }}>{`Legacy Cash Flow Updates endpoints`}</h3>
    <Callout warning mdxType="Callout">
      <p>{`The `}<inlineCode parentName="p">{`/cra/monitoring_insights/`}</inlineCode>{` endpoints below are the Cash Flow Updates API. They are deprecated and closed to new integrations, and will stop functioning on August 20, 2027, after which requests to them will return errors. Use the `}<inlineCode parentName="p">{`/cra/servicing/subscription/`}</inlineCode>{` endpoints above instead; for details, see `}<a parentName="p" {...{
          "href": "/docs/check/servicing"
        }}>{`Servicing`}</a>{` and `}<a parentName="p" {...{
          "href": "/docs/check/migrate-from-cash-flow-updates"
        }}>{`Migrate from Cash Flow Updates`}</a>{`.`}</p>
    </Callout>
    <h4 {...{
      "id": "cramonitoring_insightsget"
    }}>{`/cra/monitoring_insights/get`}</h4>
    <Schema method='POST' route='/cra/monitoring_insights/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/monitoring_insights/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/monitoring_insights/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw",
  "consumer_report_permissible_purpose": "ACCOUNT_REVIEW_CREDIT"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craMonitoringInsightsGet({
    user_id: 'usr_9nSp2KuZ2x4JDw',
    consumer_report_permissible_purpose: 'ACCOUNT_REVIEW_CREDIT',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraMonitoringInsightsGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw',
  consumer_report_permissible_purpose=MonitoringConsumerReportPermissiblePurpose('ACCOUNT_REVIEW_CREDIT'),
)

response = client.cra_monitoring_insights_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraMonitoringInsightsGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw',
    consumer_report_permissible_purpose: 'ACCOUNT_REVIEW_CREDIT',
  }
)

response = client.cra_monitoring_insights_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraMonitoringInsightsGetRequest request = new CraMonitoringInsightsGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw")
  .consumerReportPermissiblePurpose(MonitoringConsumerReportPermissiblePurpose.ACCOUNT_REVIEW_CREDIT);

Response<CraMonitoringInsightsGetResponse> response = client
  .craMonitoringInsightsGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraMonitoringInsightsGetRequest("ACCOUNT_REVIEW_CREDIT")
request.SetUserToken("user-environment-12345678-abcd-4bcd-abcd-1234567890ab")

response, _, err := client.PlaidApi.
  CraMonitoringInsightsGet(ctx).
  CraMonitoringInsightsGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraMonitoringInsightsGetRequest{ConsumerReportPermissiblePurpose: "ACCOUNT_REVIEW_CREDIT"}
request.UserToken = plaid.String("user-environment-12345678-abcd-4bcd-abcd-1234567890ab")

response, err := client.MonitoringInsights.Get(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/monitoring_insights/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "cramonitoring_insightssubscribe"
    }}>{`/cra/monitoring_insights/subscribe`}</h4>
    <Schema method='POST' route='/cra/monitoring_insights/subscribe' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/monitoring_insights/subscribe' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/monitoring_insights/subscribe \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw",
  "item_id": "eVBnVMp7zdTJLkRNr33Rs6zr7KNJqBFL9DrE6",
  "webhook": "https://example.com/webhook",
  "income_categories": ["SALARY"]
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craMonitoringInsightsSubscribe({
    user_id: 'usr_9nSp2KuZ2x4JDw',
    item_id: 'eVBnVMp7zdTJLkRNr33Rs6zr7KNJqBFL9DrE6',
    webhook: 'https://example.com/webhook',
    income_categories: [CreditBankIncomeCategory.Salary],
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraMonitoringInsightsSubscribeRequest(
  user_id='usr_9nSp2KuZ2x4JDw',
  item_id='eVBnVMp7zdTJLkRNr33Rs6zr7KNJqBFL9DrE6',
  webhook='https://example.com/webhook',
  income_categories=[CreditBankIncomeCategory('SALARY')],
)

response = client.cra_monitoring_insights_subscribe(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraMonitoringInsightsSubscribeRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw',
    item_id: 'eVBnVMp7zdTJLkRNr33Rs6zr7KNJqBFL9DrE6',
    webhook: 'https://example.com/webhook',
    income_categories: ['SALARY'],
  }
)

response = client.cra_monitoring_insights_subscribe(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraMonitoringInsightsSubscribeRequest request = new CraMonitoringInsightsSubscribeRequest()
  .userId("usr_9nSp2KuZ2x4JDw")
  .itemId("eVBnVMp7zdTJLkRNr33Rs6zr7KNJqBFL9DrE6")
  .webhook("https://example.com/webhook")
  .incomeCategories(Arrays.asList(CreditBankIncomeCategory.SALARY));

Response<CraMonitoringInsightsSubscribeResponse> response = client
  .craMonitoringInsightsSubscribe(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraMonitoringInsightsSubscribeRequest("https://example.com/webhook")
request.SetUserToken("user-environment-12345678-abcd-4bcd-abcd-1234567890ab")
request.SetItemId("eVBnVMp7zdTJLkRNr33Rs6zr7KNJqBFL9DrE6")
request.SetIncomeCategories([]plaid.CreditBankIncomeCategory{plaid.CREDITBANKINCOMECATEGORY_SALARY})

response, _, err := client.PlaidApi.
  CraMonitoringInsightsSubscribe(ctx).
  CraMonitoringInsightsSubscribeRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraMonitoringInsightsSubscribeRequest{Webhook: "https://example.com/webhook"}
request.UserToken = plaid.String("user-environment-12345678-abcd-4bcd-abcd-1234567890ab")
request.ItemID = plaid.String("eVBnVMp7zdTJLkRNr33Rs6zr7KNJqBFL9DrE6")
request.IncomeCategories = []plaid.CreditBankIncomeCategory{plaid.CreditBankIncomeCategorySalary}

response, err := client.MonitoringInsights.Subscribe(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/monitoring_insights/subscribe' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "cramonitoring_insightsunsubscribe"
    }}>{`/cra/monitoring_insights/unsubscribe`}</h4>
    <Schema method='POST' route='/cra/monitoring_insights/unsubscribe' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/cra/monitoring_insights/unsubscribe' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/cra/monitoring_insights/unsubscribe \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "subscription_id": "f17efbdd-caab-4278-8ece-963511cd3d51"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.craMonitoringInsightsUnsubscribe({
    subscription_id: 'f17efbdd-caab-4278-8ece-963511cd3d51',
  });
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CraMonitoringInsightsUnsubscribeRequest(
  subscription_id='f17efbdd-caab-4278-8ece-963511cd3d51',

)

response = client.cra_monitoring_insights_unsubscribe(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CraMonitoringInsightsUnsubscribeRequest.new(
  {
    subscription_id: 'f17efbdd-caab-4278-8ece-963511cd3d51',
  }
)

response = client.cra_monitoring_insights_unsubscribe(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CraMonitoringInsightsUnsubscribeRequest request = new CraMonitoringInsightsUnsubscribeRequest()
  .subscriptionId("f17efbdd-caab-4278-8ece-963511cd3d51");

Response<CraMonitoringInsightsUnsubscribeResponse> response = client
  .craMonitoringInsightsUnsubscribe(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCraMonitoringInsightsUnsubscribeRequest(
  "f17efbdd-caab-4278-8ece-963511cd3d51",
)

response, _, err := client.PlaidApi.
  CraMonitoringInsightsUnsubscribe(ctx).
  CraMonitoringInsightsUnsubscribeRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CraMonitoringInsightsUnsubscribeRequest{SubscriptionID: "f17efbdd-caab-4278-8ece-963511cd3d51"}

response, err := client.MonitoringInsights.Unsubscribe(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/cra/monitoring_insights/unsubscribe' type='response' mdxType="Schema" />
    <h3 {...{
      "id": "webhooks"
    }}>{`Webhooks`}</h3>
    <p>{`When you create a new report, either by creating a Link token with a Plaid Check product, or by calling `}<inlineCode parentName="p">{`/cra/check_report/create`}</inlineCode>{`, Plaid Check will start generating a report for you. When the report has been created (or the report creation fails), Plaid Check will let you know by sending you either a `}<inlineCode parentName="p">{`CHECK_REPORT: USER_CHECK_REPORT_READY`}</inlineCode>{` or `}<inlineCode parentName="p">{`CHECK_REPORT: USER_CHECK_REPORT_FAILED`}</inlineCode>{` webhook.`}</p>
    <Callout mdxType="Callout">
      <p>{`Customers who first called `}<inlineCode parentName="p">{`/user/create`}</inlineCode>{` after December 10, 2025 will receive the `}<inlineCode parentName="p">{`USER_CHECK_REPORT_READY`}</inlineCode>{` / `}<inlineCode parentName="p">{`USER_CHECK_REPORT_FAILED`}</inlineCode>{` webhooks. Customers who integrated before this date will receive both the older `}<inlineCode parentName="p">{`CHECK_REPORT_READY`}</inlineCode>{` / `}<inlineCode parentName="p">{`CHECK_REPORT_FAILED`}</inlineCode>{` webhooks and the new ones. For more details, see `}<a parentName="p" {...{
          "href": "/docs/api/users/user-apis"
        }}>{`new User APIs`}</a>{`.`}</p>
    </Callout>
    <h4 {...{
      "id": "user_check_report_ready"
    }}><inlineCode parentName="h4">{`USER_CHECK_REPORT_READY`}</inlineCode></h4>
    <Schema model='CraUserCheckReportReadyWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "user_check_report_failed"
    }}><inlineCode parentName="h4">{`USER_CHECK_REPORT_FAILED`}</inlineCode></h4>
    <Schema model='CraUserCheckReportFailedWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "check_report_ready"
    }}><inlineCode parentName="h4">{`CHECK_REPORT_READY`}</inlineCode></h4>
    <Schema model='CraCheckReportReadyWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "check_report_failed"
    }}><inlineCode parentName="h4">{`CHECK_REPORT_FAILED`}</inlineCode></h4>
    <Schema model='CraCheckReportFailedWebhook' type='model' mdxType="Schema" />
    <h3 {...{
      "id": "servicing-webhooks"
    }}>{`Servicing webhooks`}</h3>
    <h4 {...{
      "id": "cra_report_updated"
    }}><inlineCode parentName="h4">{`CRA_REPORT_UPDATED`}</inlineCode></h4>
    <Schema model='CraReportUpdatedWebhook' type='model' mdxType="Schema" />
    <h3 {...{
      "id": "legacy-cash-flow-updates-webhooks"
    }}>{`Legacy Cash Flow Updates webhooks`}</h3>
    <Callout warning mdxType="Callout">
      <p>{`The webhooks below belong to Cash Flow Updates and are deprecated, for integrations created before August 20, 2026. `}<inlineCode parentName="p">{`CASH_FLOW_INSIGHTS_UPDATED`}</inlineCode>{` is fired only for integrations created between December 10, 2025 and August 20, 2026. The remaining five webhooks fire only for integrations created before December 10, 2025. For more details, see `}<a parentName="p" {...{
          "href": "/docs/api/users/user-apis"
        }}>{`New User APIs`}</a>{` and `}<a parentName="p" {...{
          "href": "/docs/check/migrate-from-cash-flow-updates"
        }}>{`Migrate from Cash Flow Updates`}</a>{`.`}</p>
    </Callout>
    <h4 {...{
      "id": "cash_flow_insights_updated"
    }}><inlineCode parentName="h4">{`CASH_FLOW_INSIGHTS_UPDATED`}</inlineCode></h4>
    <Schema model='CashFlowUpdatesInsightsV2Webhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "insights_updated"
    }}><inlineCode parentName="h4">{`INSIGHTS_UPDATED`}</inlineCode></h4>
    <Schema model='CashFlowUpdatesInsightsWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "large_deposit_detected"
    }}><inlineCode parentName="h4">{`LARGE_DEPOSIT_DETECTED`}</inlineCode></h4>
    <Schema model='CashFlowUpdatesLargeDepositWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "low_balance_detected"
    }}><inlineCode parentName="h4">{`LOW_BALANCE_DETECTED`}</inlineCode></h4>
    <Schema model='CashFlowUpdatesLowBalanceWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "new_loan_payment_detected"
    }}><inlineCode parentName="h4">{`NEW_LOAN_PAYMENT_DETECTED`}</inlineCode></h4>
    <Schema model='CashFlowUpdatesNewLoanPaymentWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "nsf_overdraft_detected"
    }}><inlineCode parentName="h4">{`NSF_OVERDRAFT_DETECTED`}</inlineCode></h4>
    <Schema model='CashFlowUpdatesNSFWebhook' type='model' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "cracheck_reportbase_reportget",
        level: 4,
        title: "/cra/check_report/base_report/get",
      },
{
        id: "cracheck_reportincome_insightsget",
        level: 4,
        title: "/cra/check_report/income_insights/get",
      },
{
        id: "cracheck_reportnetwork_insightsget",
        level: 4,
        title: "/cra/check_report/network_insights/get",
      },
{
        id: "cracheck_reportpartner_insightsget",
        level: 4,
        title: "/cra/check_report/partner_insights/get",
      },
{
        id: "cracheck_reportpdfget",
        level: 4,
        title: "/cra/check_report/pdf/get",
      },
{
        id: "cracheck_reportcashflow_insightsget",
        level: 4,
        title: "/cra/check_report/cashflow_insights/get",
      },
{
        id: "cracheck_reportlend_scoreget",
        level: 4,
        title: "/cra/check_report/lend_score/get",
      },
{
        id: "cracheck_reportverificationget",
        level: 4,
        title: "/cra/check_report/verification/get",
      },
{
        id: "cracheck_reportverificationpdfget",
        level: 4,
        title: "/cra/check_report/verification/pdf/get",
      },
{
        id: "cracheck_reportcreate",
        level: 4,
        title: "/cra/check_report/create",
      },
{
        id: "craservicingsubscriptioncreate",
        level: 4,
        title: "/cra/servicing/subscription/create",
      },
{
        id: "craservicingsubscriptionget",
        level: 4,
        title: "/cra/servicing/subscription/get",
      },
{
        id: "craservicingsubscriptionlist",
        level: 4,
        title: "/cra/servicing/subscription/list",
      },
{
        id: "craservicingsubscriptionupdate",
        level: 4,
        title: "/cra/servicing/subscription/update",
      },
{
        id: "craservicingsubscriptiondelete",
        level: 4,
        title: "/cra/servicing/subscription/delete",
      },
{
        id: "legacy-cash-flow-updates-endpoints",
        level: 3,
        title: "Legacy Cash Flow Updates endpoints",
      },
{
        id: "cramonitoring_insightsget",
        level: 4,
        title: "/cra/monitoring_insights/get",
      },
{
        id: "cramonitoring_insightssubscribe",
        level: 4,
        title: "/cra/monitoring_insights/subscribe",
      },
{
        id: "cramonitoring_insightsunsubscribe",
        level: 4,
        title: "/cra/monitoring_insights/unsubscribe",
      },
{
        id: "webhooks",
        level: 3,
        title: "Webhooks",
      },
{
        id: "user_check_report_ready",
        level: 4,
        title: "USER_CHECK_REPORT_READY",
      },
{
        id: "user_check_report_failed",
        level: 4,
        title: "USER_CHECK_REPORT_FAILED",
      },
{
        id: "check_report_ready",
        level: 4,
        title: "CHECK_REPORT_READY",
      },
{
        id: "check_report_failed",
        level: 4,
        title: "CHECK_REPORT_FAILED",
      },
{
        id: "servicing-webhooks",
        level: 3,
        title: "Servicing webhooks",
      },
{
        id: "cra_report_updated",
        level: 4,
        title: "CRA_REPORT_UPDATED",
      },
{
        id: "legacy-cash-flow-updates-webhooks",
        level: 3,
        title: "Legacy Cash Flow Updates webhooks",
      },
{
        id: "cash_flow_insights_updated",
        level: 4,
        title: "CASH_FLOW_INSIGHTS_UPDATED",
      },
{
        id: "insights_updated",
        level: 4,
        title: "INSIGHTS_UPDATED",
      },
{
        id: "large_deposit_detected",
        level: 4,
        title: "LARGE_DEPOSIT_DETECTED",
      },
{
        id: "low_balance_detected",
        level: 4,
        title: "LOW_BALANCE_DETECTED",
      },
{
        id: "new_loan_payment_detected",
        level: 4,
        title: "NEW_LOAN_PAYMENT_DETECTED",
      },
{
        id: "nsf_overdraft_detected",
        level: 4,
        title: "NSF_OVERDRAFT_DETECTED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
